import { useQuery } from "@tanstack/react-query";
import type { CustomerOrdersTrendParams } from "./statisticsApi";
import { getCustomerOrdersTrend } from "./statisticsApi";

export function useCustomerOrdersTrend(customerId: string | null, params: CustomerOrdersTrendParams) {
  return useQuery({
    queryKey: ["admin", "statistics", "customers", customerId, "orders-trend", params],
    queryFn: ({ signal }) => getCustomerOrdersTrend(customerId as string, params, signal),
    enabled: customerId !== null,
  });
}
